import axios from './axios'
import qs from "qs";

function service(endpoint) {

    function fetchSummary(data) {
        return axios.get(`${endpoint}/summary`, { params: data, paramsSerializer: params => qs.stringify(params, { encode: false })  }).then(response => {
            return response.data;
        }).catch(e => {
            throw e
        });
    }

    return {
        fetchSummary
    }
}

export default service
